import React from "react"
import "../../App.less"
import { Radio, Select, Form, Popover } from "antd"
import IconTooltip from "./IconTooltip"
import AppStore from "../../Configs/Store/index"
import Dropdown_Icon from "../../assets/Dropdown_Icon.svg"
import Icon from "@ant-design/icons"
import Image from "./Image"

const DropdownIcon = () => <Image src={Dropdown_Icon} alt={""} />

const RadioGroup = ({
  className,
  formClass,
  jsonData,
  dynamicTitle,
  propValue,
  hideValue,
  colon,
  onChange,
  onToolTipClick,
  type,
  infoIcon,
  condition,
  extraCon,
  disableQ,
  reverse,
  highestToggle,
  styleName,
  formName,
  validate,
  validateMesssage,
  dropdownIcon,
  overClassName,
  place = "right",
  ddParent,
  ...props
}) => {
  // console.info("Condtion :", jsonData)
  var disabledQFlag = false

  if (condition === undefined) condition = ""

  if (hideValue === undefined) hideValue = []

  if (disableQ !== undefined) {
    disabledQFlag = disableQ
  }

  const containsData = (array, value) => {
    // console.info("ARRAY :", array)
    if (array === undefined) return false
    else return array.includes(value)
  }

  const ddParentContainer = () => {
    if (ddParent !== undefined) {
      return document.getElementById(`${ddParent}`)
    } else {
      return document.body
    }
  }

  return (
    <Form.Item
      name={formName}
      colon={colon}
      className={formClass}
      rules={[{ required: validate, message: validateMesssage }]}
      label={
        <>
          {infoIcon ? (
            <div className={className}>
              {dynamicTitle === "" ? jsonData["title"] : dynamicTitle}
              <IconTooltip title={jsonData["tooltip"]} overClassName={overClassName} place={place} onClick={onToolTipClick} zIndex={AppStore.device === 0 ? -1 : null} />
            </div>
          ) : (
            <div className={className}>{dynamicTitle === "" ? jsonData["title"] : dynamicTitle}</div>
          )}
        </>
      }
    >
      {type === 0 ? (
        <Select
          disabled={disabledQFlag}
          options={jsonData["options"].filter((x) => !hideValue.includes(x["value"]))}
          getPopupContainer={ddParentContainer}
          onChange={onChange}
          suffixIcon={<Icon component={dropdownIcon === undefined ? DropdownIcon : dropdownIcon} className="ant-select-suffix" />}
          {...props}
        />
      ) : (
        <Radio.Group
          // options={jsonData['options']}
          optionType="button"
          onChange={onChange}
          {...props}
          // className={'marginBottom10'}
        >
          {Object.entries(jsonData["options"])
            .filter(([fi, fv], fI) => !hideValue.includes(fv["value"]))
            .map(([i, v], index) => (
              <span key={v.value}>
                {v.hoverText === undefined ? (
                  <Radio.Button
                    value={v.value}
                    style={AppStore.device === 0 ? styles[0][styleName] : styles[1][styleName]}
                    disabled={disabledQFlag ? disableQ : (condition === "" ? false : reverse ? condition === v.value : condition !== v.value) || containsData(extraCon, v.value)}
                  >
                    {v.label}
                  </Radio.Button>
                ) : (
                  <Popover placement={AppStore.device === 0 ? "topLeft" : "bottomLeft"} title={v.hoverText} trigger="click" visible={highestToggle}>
                    <Radio.Button
                      value={v.value}
                      style={AppStore.device === 0 ? styles[0][styleName] : styles[1][styleName]}
                      disabled={disabledQFlag ? disableQ : (condition === "" ? false : reverse ? condition === v.value : condition !== v.value) || containsData(extraCon, v.value)}
                    >
                      {v.label}
                    </Radio.Button>
                  </Popover>
                )}
              </span>
            ))}
        </Radio.Group>
      )}
    </Form.Item>
  )
}

const styles = {
  1: {
    radioGender: {
      minWidth: 115,
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    radioBuyFor: {
      minWidth: 115,

      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    radioHowPlan: {
      maxWidth: 100,
      width: "100%",
      height: 32,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    radioProcced: {
      maxWidth: 80,
      width: "100%",
      height: 32,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  0: {
    radioGender: {
      display: "flex",
      minWidth: 101,
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    radioBuyFor: {
      minWidth: 157,

      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    radioAnnualIncome: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: 0,
    },
    radioHowPlan: {
      height: 30,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
    radioProcced: {
      height: 36,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
  },
}

export default RadioGroup
